import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Accordion, AccordionItem, AccordionHeader, AccordionBody, Table } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const AppTokenConsentFeedback: React.FC = () => {
    const { t } = useTranslation(['coomon']);
    const [searchParams, setSearchParams] = useSearchParams();
    const [open, setOpen] = useState('');
    const isError = searchParams.has("error"); 


    useEffect(() => {
        if (isError) {
            setOpen("errorinfo")
        }
    }, [isError])

    const toggleErrors = (id: string) => {
        if (open === id) {
            setOpen('');
        }
        else {
            setOpen(id);
        }
    };

    const consentFeedback = () => {
        const elements = Array.from(searchParams)
            .map(([key, value]) => <tr><td data-label={t('consentFeedback.debugParamsListHeaders.name', { ns: 'common' })}>{key}</td><td data-label={t('consentFeedback.debugParamsListHeaders.value', { ns: 'common' })}>{value}</td></tr>);

        if (elements.length === 0) {
            return null;
        }


        return (
            <Accordion flush open={open} toggle={toggleErrors} className="app-token-consent__parameters" >
                <AccordionItem>
                    <AccordionHeader targetId="errorinfo">{t('consentFeedback.debugParams', { ns: 'common' })}</AccordionHeader>
                    <AccordionBody accordionId="errorinfo">
                        <Table bordered>
                            <thead>
                                <tr>
                                    <th>{t('consentFeedback.debugParamsListHeaders.name', { ns: 'common' })}</th>
                                    <th>{t('consentFeedback.debugParamsListHeaders.value', { ns: 'common' })}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {elements}
                            </tbody>
                        </Table>
                    </AccordionBody>
                </AccordionItem>
            </Accordion>
        );
    };

    return (
        <div className="app-token-consent">
            <div className="app-token-consent__wrapper">
                <div className="app-token-consent__container">
                    <h2 className="app-token-consent__header">{t('consentFeedback.thankYou', { ns: 'common' })}</h2>
                    <p>{isError ? t('consentFeedback.hasErrorsMessage', { ns: 'common' }) : t('consentFeedback.successfulMessage', { ns: 'common' }) }</p>
                    {consentFeedback()}
                </div>
            </div>
    </div>);
}

export default AppTokenConsentFeedback;
